import React from 'react';
import LegalLayout from '../components/LegalLayout';

const CancellationRefund = () => (
  <LegalLayout title="Cancelaciones y Reembolsos" subtitle="Legal" lastUpdated="13 de mayo de 2026">
    <p>
      La presente política regula las cancelaciones de suscripciones y los
      reembolsos en <strong>Teko</strong>. Su finalidad es brindar al usuario
      total claridad respecto de sus derechos como cliente.
    </p>

    <h2>1. Cómo cancelar la suscripción</h2>
    <p>
      El usuario puede cancelar su suscripción paga en cualquier momento, sin
      penalización alguna, siguiendo estos pasos:
    </p>
    <ul>
      <li>Ingrese a su cuenta y diríjase a la sección <strong>Membresía</strong>.</li>
      <li>Seleccione la opción <strong>"Cancelar suscripción"</strong>.</li>
      <li>Confirme la cancelación. Recibirá un correo electrónico de confirmación.</li>
    </ul>
    <p>
      En caso de dificultades técnicas para realizar la cancelación, el usuario
      podrá escribirnos a{' '}
      <a href="mailto:asistencia.teko@gmail.com">asistencia.teko@gmail.com</a>{' '}
      desde el correo electrónico registrado. Las cancelaciones serán
      procesadas manualmente en un plazo inferior a 24 horas hábiles.
    </p>

    <h2>2. Consecuencias de la cancelación</h2>
    <ul>
      <li>
        El usuario <strong>conserva acceso completo</strong> a las
        funcionalidades de su plan hasta la fecha de finalización del período
        ya abonado.
      </li>
      <li>
        Al vencer dicho período, la cuenta pasará automáticamente al plan{' '}
        <strong>gratuito</strong>. La totalidad de los datos (hábitos, metas,
        diario, entre otros) se conservará, aplicándose únicamente los límites
        del plan gratuito.
      </li>
      <li>No se generarán cobros futuros una vez cancelada la suscripción.</li>
      <li>
        El usuario podrá reactivar la suscripción en cualquier momento desde la
        sección Membresía.
      </li>
    </ul>

    <h2>3. Política de reembolsos</h2>

    <h3>3.1. Período de garantía (7 días)</h3>
    <p>
      Se ofrece <strong>reembolso completo</strong> dentro de los{' '}
      <strong>7 días corridos</strong> posteriores al primer cobro, siempre que
      se cumplan las siguientes condiciones:
    </p>
    <ul>
      <li>Que se trate de la primera suscripción a un plan pago de Teko.</li>
      <li>Que el usuario no haya consumido más del 30% de los créditos de inteligencia artificial del período.</li>
      <li>
        Que la solicitud de reembolso sea remitida por correo electrónico a{' '}
        <a href="mailto:asistencia.teko@gmail.com">asistencia.teko@gmail.com</a>,
        indicando la dirección de correo registrada y el motivo de la
        cancelación.
      </li>
    </ul>

    <h3>3.2. Reembolsos por error de cobro</h3>
    <p>
      En caso de cobro erróneo (doble cobro, cobro posterior a la cancelación o
      monto incorrecto), se reembolsará el 100% del cargo en un plazo máximo
      de <strong>10 días hábiles</strong>. Para ello, el usuario deberá
      comunicar los detalles del cobro (fecha, monto e identificador de
      transacción) a fin de que el caso sea revisado de inmediato.
    </p>

    <h3>3.3. Casos sin reembolso</h3>
    <p>No se procesarán reembolsos en los siguientes supuestos:</p>
    <ul>
      <li>Cancelaciones realizadas con posterioridad a los primeros 7 días del primer pago.</li>
      <li>
        Renovaciones automáticas posteriores a la primera (si la cancelación
        no se realizó a tiempo, el cobro se ejecutará y no será reembolsable).
      </li>
      <li>
        Consumo superior al 30% de los créditos de inteligencia artificial del
        período (se considera que el usuario ya ha recibido valor sustancial
        del plan).
      </li>
      <li>
        Cancelaciones motivadas por modificaciones futuras de precios que hayan
        sido comunicadas con 30 días de anticipación.
      </li>
      <li>Suspensión de la cuenta por incumplimiento de los Términos y Condiciones.</li>
    </ul>

    <h3>3.4. Plan Trimestral</h3>
    <p>
      En el caso del plan <strong>Trimestral</strong> (14,5 USD por 3 meses),
      el período de garantía de 7 días se computa desde el primer cobro. Si la
      cancelación se realiza entre el día 8 y el día 90, no procederá
      reembolso alguno; no obstante, el usuario conservará el acceso hasta la
      finalización del trimestre abonado.
    </p>

    <h2>4. Procesamiento del reembolso</h2>
    <ul>
      <li>
        Los reembolsos aprobados se procesarán a través del{' '}
        <strong>proveedor de servicios de pago autorizado</strong>, utilizando
        el mismo medio de pago empleado originalmente.
      </li>
      <li>
        El tiempo de acreditación dependerá del banco o emisor del usuario,
        pudiendo demorar entre 5 y 15 días hábiles.
      </li>
      <li>
        El usuario recibirá un correo electrónico de confirmación una vez
        iniciado el reembolso desde nuestros sistemas.
      </li>
    </ul>

    <h2>5. Resolución de disputas</h2>
    <p>
      En caso de disconformidad con la respuesta brindada a una solicitud de
      reembolso, el usuario podrá escalar el caso escribiendo a{' '}
      <a href="mailto:asistencia.teko@gmail.com">asistencia.teko@gmail.com</a>{' '}
      con el asunto <strong>"Apelación de reembolso"</strong>. Cada caso será
      revisado en un plazo máximo de 7 días hábiles. De persistir la
      discrepancia, el usuario podrá iniciar una disputa formal ante el
      proveedor de pagos utilizado o ante las autoridades de defensa del
      consumidor de su país.
    </p>

    <h2>6. Contacto</h2>
    <p>
      Para cualquier solicitud de cancelación o reembolso, el usuario podrá
      escribir a{' '}
      <a href="mailto:asistencia.teko@gmail.com">asistencia.teko@gmail.com</a>.
    </p>
  </LegalLayout>
);

export default CancellationRefund;
